import { useMemo } from 'react';

import type { NormalizedFormValues } from '#src/app/pages/petitionDetails/shared/types';
import type { SignPetitionHookInput } from '#src/app/shared/hooks/signature';

import { useCurrentUserSignData } from '../useCurrentUserSignData';
import { usePromotionSignData } from '../usePromotionSignData';
import { useQuerySignData } from '../useQuerySignData';

type Result = Omit<SignPetitionHookInput, keyof NormalizedFormValues>;

const STATIC_DATA: Pick<SignPetitionHookInput, 'resubmit' | 'pendingReason' | 'userSawSignInterrupt'> = {
	resubmit: false,
	pendingReason: null,
	userSawSignInterrupt: false,
};

export function useSignData(): Result {
	const queryData = useQuerySignData();
	const promotionData = usePromotionSignData();
	const currentUserData = useCurrentUserSignData();

	return useMemo(
		() => ({
			...currentUserData,
			...queryData,
			...promotionData,
			...STATIC_DATA,
		}),
		[queryData, promotionData, currentUserData],
	);
}
